const faqData = [
  {
    q: '黄桃视频是什么类型的视频平台？',
    a: '黄桃视频是一个免费高清在线视频平台，与樱花视频、糖豆视频、蘑菇视频同属优质视频服务。我们提供电影、电视剧、综艺、动漫、纪录片等全品类内容，支持网站和APP双端访问，所有资源免费在线观看，无需注册即可使用。',
  },
  {
    q: '黄桃视频是否需要付费或注册会员？',
    a: '黄桃视频始终坚持免费服务，用户无需付费或注册会员即可畅享全部影视内容。我们通过技术优化降低运营成本，让每一位影迷都能零门槛观看高清视频。如遇需要付费的提示，请确认您访问的是黄桃视频官方入口。',
  },
  {
    q: '黄桃视频APP在哪里下载？安全吗？',
    a: '黄桃视频APP可在本页面"APP下载"区域获取官方下载入口，支持安卓和iOS双端。我们承诺APP不含恶意代码和强制广告，安装包经过安全检测。请务必通过本官网入口下载，避免从不明来源获取安装包以保障设备安全。',
  },
  {
    q: '视频播放卡顿或加载失败怎么办？',
    a: '黄桃视频采用多线CDN加速技术，绝大多数情况下播放流畅不缓冲。如偶遇卡顿，建议：① 切换网络环境（WiFi/移动数据）；② 刷新页面重试；③ 清理浏览器缓存；④ 如使用APP请更新至最新版本。我们的技术团队7×24小时保障服务稳定。',
  },
  {
    q: '黄桃视频和樱花视频、糖豆视频有什么区别？',
    a: '黄桃视频与樱花视频、糖豆视频、蘑菇视频同属免费视频平台赛道，各有侧重。黄桃视频在内容覆盖广度、更新速度和播放流畅度方面持续优化，尤其注重用户体验和界面设计。不同平台各有特色，建议根据个人观影偏好自由选择，黄桃视频欢迎您的体验和比较。',
  },
];

const commentsData = [
  {
    name: '光影追梦人',
    text: '用黄桃视频半年了，资源是真的全，国产剧、韩剧更新速度很快，高清画质看得很舒服。之前用樱花视频后来转到黄桃，感觉黄桃界面更清爽，推荐给身边朋友了。',
    tag: '忠实用户',
  },
  {
    name: '周末影咖',
    text: '找了好几个视频平台，黄桃视频是目前用着最顺手的。电影片库很大，很多冷门佳片都能找到，而且真的免费不用充会员，这点太良心了。',
    tag: '电影爱好者',
  },
  {
    name: '追剧小达人',
    text: '之前一直用糖豆视频追剧，后来朋友推荐了黄桃视频APP，试了一下发现APP体验很好，缓存功能很实用，地铁上也能看。现在两个平台换着用，各有各的好。',
    tag: '剧集控',
  },
  {
    name: '二次元阿宅',
    text: '动漫资源很丰富这点我必须夸，新番同步快，老番也齐全。之前蘑菇视频上的番剧黄桃基本都有，而且播放流畅度更好。二次元用户放心入，不会让你失望。',
    tag: '动漫迷',
  },
];

const mediaData = [
  {
    title: '近期热播剧集大盘点',
    desc: '古装大剧、都市情感、悬疑推理……看看最近大家都在追什么',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20peach%20and%20coral%20abstract%20gradient%20with%20cinematic%20wide%20composition%2C%20soft%20flowing%20curves%2C%20drama%20series%20theme%2C%20modern%20digital%20art%2C%20clean%20minimalist%20design%2C%20commercial%20photography%20style%2C%20high%20quality%20illustration&width=800&height=450&seq=huangtao-media-1&orientation=landscape',
  },
  {
    title: '院线新片速览指南',
    desc: '最新上映热门电影一览，第一时间掌握观影风向',
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20and%20peach%20toned%20abstract%20cinematic%20background%2C%20soft%20dramatic%20lighting%2C%20movie%20premiere%20atmosphere%2C%20modern%20digital%20composition%2C%20clean%20minimalist%20design%2C%20commercial%20photography%20style%2C%20warm%20inviting%20mood&width=800&height=450&seq=huangtao-media-2&orientation=landscape',
  },
  {
    title: '综艺爆笑名场面合集',
    desc: '搞笑笑到停不下来，精选综艺最欢乐的时刻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20peach%20and%20amber%20abstract%20composition%20with%20playful%20energy%2C%20variety%20show%20theme%2C%20colorful%20gradient%20waves%2C%20joyful%20atmosphere%2C%20modern%20digital%20art%2C%20clean%20minimalist%20design%2C%20commercial%20style&width=800&height=450&seq=huangtao-media-3&orientation=landscape',
  },
  {
    title: '高分纪录片推荐',
    desc: '豆瓣高分纪录片精选，拓展视野的视觉盛宴',
    imageUrl: 'https://readdy.ai/api/search-image?query=Serene%20warm%20toned%20abstract%20landscape%20with%20soft%20gradients%2C%20documentary%20cinematography%20aesthetic%2C%20natural%20light%2C%20peaceful%20atmosphere%2C%20modern%20digital%20art%2C%20clean%20minimalist%20design%2C%20high%20quality%20illustration&width=800&height=450&seq=huangtao-media-4&orientation=landscape',
  },
  {
    title: '动漫新番追更日历',
    desc: '每周更新动漫时间表，热门番剧追更不迷路',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dreamy%20peach%20and%20coral%20abstract%20digital%20art%20with%20flowing%20gradients%2C%20animation%20themed%20visual%2C%20soft%20geometric%20shapes%2C%20modern%20illustration%20style%2C%20clean%20minimalist%20design%2C%20commercial%20photography%20style&width=800&height=450&seq=huangtao-media-5&orientation=landscape',
  },
];

const indexData = [
  { title: '电影大全', desc: '动作·喜剧·爱情·科幻·恐怖', icon: 'ri-movie-2-line' },
  { title: '电视剧库', desc: '国产·韩剧·美剧·日剧·泰剧', icon: 'ri-tv-2-line' },
  { title: '综艺合集', desc: '真人秀·脱口秀·音乐·竞技', icon: 'ri-emotion-laugh-line' },
  { title: '动漫番剧', desc: '热血·恋爱·搞笑·奇幻·日常', icon: 'ri-rocket-2-line' },
  { title: '纪录片库', desc: '自然·历史·科技·美食·人文', icon: 'ri-earth-line' },
  { title: '短剧频道', desc: '微短剧·竖屏剧·快节奏爽剧', icon: 'ri-smartphone-line' },
  { title: '少儿天地', desc: '动画·早教·儿歌·亲子互动', icon: 'ri-heart-3-line' },
  { title: '午夜专场', desc: '悬疑·惊悚·犯罪·暗黑系', icon: 'ri-moon-line' },
];

export function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-base text-foreground-600">关于黄桃视频，你想知道的都在这里</p>
          </div>
          <div className="space-y-4">
            {faqData.map((item) => (
              <details key={item.q} className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden" open>
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                  <h3 className="text-base font-semibold text-foreground-950 pr-6">{item.q}</h3>
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                    <i className="ri-add-line text-primary-600 text-sm"></i>
                  </span>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              用户评价
            </h2>
            <p className="mt-3 text-base text-foreground-600">来自真实用户的观影体验分享</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {commentsData.map((c) => (
              <div key={c.name} className="rounded-2xl bg-background-100 border border-background-200/70 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-primary-600 font-bold text-sm">{c.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{c.name}</p>
                    <span className="inline-block mt-0.5 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {c.tag}
                    </span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
                <div className="flex items-center gap-1 mt-3 text-accent-500">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精彩推荐
            </h2>
            <p className="mt-3 text-base text-foreground-600">编辑精选优质内容，发现更多观影乐趣</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaData.map((item) => (
              <div key={item.title} className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-play-fill text-background-50 text-2xl"></i>
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              主题索引
            </h2>
            <p className="mt-3 text-base text-foreground-600">快速找到你感兴趣的影视分类</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {indexData.map((item) => (
              <a
                key={item.title}
                href="#cards"
                className="flex items-start gap-3 p-5 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
              >
                <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                  <i className={`${item.icon} text-primary-600 group-hover:text-background-50 text-lg transition-colors duration-200`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}